import {
  JiraSoftwareSiteAriResourceOwner,
  JiraSoftwareSiteAriResourceType
} from "./chunk-CKKWVELS.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/jira-software/site/manifest.ts
var jiraSoftwareSiteAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: JiraSoftwareSiteAriResourceOwner,
  resourceType: JiraSoftwareSiteAriResourceType,
  resourceIdSlug: "{siteId}",
  resourceIdSegmentFormats: {
    siteId: /[a-zA-Z0-9_\-.]{1,255}/
    // eslint-disable-line no-useless-escape
  }
};

// src/jira-software/site/index.ts
var JiraSoftwareSiteAri = class _JiraSoftwareSiteAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.resourceIdSegmentValues.siteId;
  }
  get siteId() {
    return this._siteId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: jiraSoftwareSiteAriStaticOpts.qualifier,
      platformQualifier: jiraSoftwareSiteAriStaticOpts.platformQualifier,
      cloudId: void 0,
      resourceOwner: jiraSoftwareSiteAriStaticOpts.resourceOwner,
      resourceType: jiraSoftwareSiteAriStaticOpts.resourceType,
      resourceId: `${opts.siteId}`,
      resourceIdSegmentValues: {
        siteId: opts.siteId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, jiraSoftwareSiteAriStaticOpts);
    return new _JiraSoftwareSiteAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, jiraSoftwareSiteAriStaticOpts);
    return new _JiraSoftwareSiteAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId
    };
  }
};

export {
  JiraSoftwareSiteAri
};
